import { render } from "./PointHis.vue?vue&type=template&id=79f6cada&scoped=true"
import script from "./PointHis.vue?vue&type=script&lang=js"
export * from "./PointHis.vue?vue&type=script&lang=js"

import "./PointHis.vue?vue&type=style&index=0&id=79f6cada&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f6cada"]])

export default __exports__